/**
 * Copyright © 2025 Indisea Software LLC. All rights reserved.
 *
 * Proprietary and confidential. Licensed, not sold. Use is subject to the
 * license agreement between Indisea Software LLC and the licensee.
 * See LICENSE for full terms.
 *
 * SPDX-License-Identifier: LicenseRef-Indisea-Proprietary
 */

import axios from 'axios';
import { BASE_API_URL } from './config';
import { toast } from 'react-toastify';
import { useAuth } from './context/AuthContext';

let setLoadingGlobal = null;
let logoutGlobal = null;

export function setGlobalLoaderSetter(setter) {
    setLoadingGlobal = setter;
}

export function setGlobalLogoutSetter(setter) {
    logoutGlobal = setter;
}

const api = axios.create({
    baseURL: BASE_API_URL,
});

// Request interceptor to show loader
api.interceptors.request.use(
    (config) => {
        if (setLoadingGlobal) setLoadingGlobal(true);
        return config;
    },
    (error) => {
        if (setLoadingGlobal) setLoadingGlobal(false);
        return Promise.reject(error instanceof Error ? error : new Error(error));
    }
);

// Response interceptor to hide loader and show errors
api.interceptors.response.use(
    (response) => {
        if (setLoadingGlobal) setLoadingGlobal(false);
        return response;
    },
    (error) => {
        if (setLoadingGlobal) setLoadingGlobal(false);
        // If unauthorized, force logout
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            if (logoutGlobal) logoutGlobal();
        }
        const message = error.response?.data?.message || error.message || 'An error occurred.';
        toast.error(message, { position: 'top-right', autoClose: 5000 });
        return Promise.reject(error instanceof Error ? error : new Error(error));
    }
);

export default api;
